import React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';

import {updateObject} from 'utils/reducerUtils';

import Countdown from 'components/Countdown';
import strings from 'utils/strings';

import wordsNo from './data/no.json';
import wordsNn from './data/nn.json';
import noNormingData from './data/no-norming.json';
import nnNormingData from './data/nn-norming.json';

const wordsObj = {
	no: wordsNo,
	nn: wordsNn,
};

const normingWordsObj = {
	no: noNormingData,
	nn: nnNormingData,
};

class Test extends React.Component {
	constructor(props) {
		super(props);

		const isDldTest = props.isDldTest ? 1 : 0;

		this.words =
			isDldTest === 1
				? normingWordsObj[strings.getLanguage()]
				: wordsObj[strings.getLanguage()];

		const results = {};

		for (const question of this.words) {
			results[question.id] = '';
		}

		this.state = {
			results,
			timeRanOut: false,
			showMissing: false,
		};

		this.questionRefs = {};
		this.handleNextStep = this.handleNextStep.bind(this);
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			prevState.timeRanOut !== this.state.timeRanOut &&
			this.state.timeRanOut
		) {
			if (this.submitButton) {
				this.submitButton.focus();
			}
		}
	}

	setResults(id, value) {
		this.setState((prevState) => ({
			results: updateObject(prevState.results, {
				[id]: value,
			}),
		}));
	}

	handleNextStep() {
		const {results, timeRanOut} = this.state;
		const {onNextStep, isSendingTestResults} = this.props;

		if (isSendingTestResults) {
			return;
		}

		const firstUnanswered = this.words.find(
			(question) => !results[question.id]
		);

		if (!timeRanOut && firstUnanswered) {
			this.setState({showMissing: true}, () => {
				const element = this.questionRefs[firstUnanswered.id];

				if (element) {
					element.scrollIntoView({
						behavior: 'smooth',
						block: 'center',
					});
				}
			});

			return;
		}

		onNextStep(results);
	}

	render() {
		const {isSendingTestResults, isDldTest} = this.props;

		const {timeRanOut, results, showMissing} = this.state;

		const hasUnanswered = this.words.some(
			(question) => !results[question.id]
		);

		const showValidation = showMissing && hasUnanswered && !timeRanOut;

		const minutes = isDldTest ? 8 : 10;
		const secondsPerMinute = 60;

		const validationMessage =
			strings.getLanguage() === 'nn'
				? 'Svar på alle dei markerte oppgåvene før du går vidare.'
				: 'Svar på alle de markerte oppgavene før du går videre.';

		return (
			<div className="lit-test lit-test--timed lit-ordforstaelse">
				<div className="lit-infobar">
					<Countdown
						duration={minutes * secondsPerMinute}
						onComplete={() => {
							this.setState({
								timeRanOut: true,
							});
						}}
					/>
				</div>

				<p>{strings.chooseSynonym}</p>

				{showValidation && (
					<p className="lit-validation-message" role="alert">
						{validationMessage}
					</p>
				)}

				<div
					className={classNames({
						'lit-questions': true,
						'time-ran-out': timeRanOut,
					})}
				>
					{this.words.map((question) => {
						const {id, choices} = question;

						const currentQuestionValue = results[id];

						if (timeRanOut && !currentQuestionValue) {
							return null;
						}

						const isUnanswered =
							showValidation && !currentQuestionValue;

						return (
							<div
								className={classNames('lit-question', {
									'lit-question--unanswered': isUnanswered,
								})}
								key={id}
								ref={(element) => {
									this.questionRefs[id] = element;
								}}
							>
								<div className="question">
									<span className="lit-input__label lit-input__label--count">
										{id}
									</span>

									<h4
										className="question__text"
										id={`ordforstaelse-question-${id}`}
									>
										{question.word}
									</h4>
								</div>

								<div
									className="choices"
									role="radiogroup"
									aria-labelledby={`ordforstaelse-question-${id}`}
									aria-invalid={isUnanswered}
								>
									{choices.map((choice) => {
										const choiceLetter = choice.letter;
										const idChoice = id + choiceLetter;

										return (
											<span
												className="lit-choice"
												key={idChoice}
											>
												<input
													checked={
														currentQuestionValue ===
														choiceLetter
													}
													className="lit-choice__field"
													disabled={timeRanOut}
													id={idChoice}
													onChange={() => {
														if (timeRanOut) {
															return;
														}

														this.setResults(
															id,
															choiceLetter
														);
													}}
													type="radio"
												/>

												<label
													className="lit-choice__label"
													htmlFor={idChoice}
												>
													<div className="checkbox" />
													{choice.choice}
												</label>
											</span>
										);
									})}
								</div>
							</div>
						);
					})}
				</div>

				<button
					type="button"
					className="lit-btn bg-primary"
					onClick={this.handleNextStep}
					ref={(ref) => {
						this.submitButton = ref;
					}}
					disabled={isSendingTestResults}
				>
					{strings.done}
				</button>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {
		testStepAnswers: {isSendingTestResults},
	} = state;

	return {
		isSendingTestResults,
	};
};

export default connect(mapStateToProps)(Test);
